import ShowMore from './ShowMore';
import './index.scss';
const initShowMore = (element) => {
    return new ShowMore(element);
};

export {
    ShowMore,
    initShowMore
};
